import React from 'react';
import Chart from 'react-apexcharts';
import './ResultsChart.scss';

function ResultsChart({ correct, total }) {
  const options = {
    chart: {
      type: 'donut',
    },
    labels: ['Correct', 'Remaining'],
    legend: {
      show: false,
    },
    stroke: {
      width: 0,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#50C878', '#E5E5E5'],
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '80%',
        },
      },
    },
  };

  const series = [correct, total - correct];

  return (
    <div className='chart-wrapper'>
      <Chart
        options={options}
        series={series}
        type='donut'
        width='100%'
        height={180}
      />
      <div className='chart-center-label'>
        <div className='chart-number'>{correct}</div>
        <div className='chart-text'>Out of {total}</div>
      </div>
    </div>
  );
}

export default ResultsChart;
